// =============================================================================
// ACTION DRAG DATA
// =============================================================================
//
// Helper for drag & drop of actions to agenda.
// Uses HTML5 drag events for cross-component dragging.
//
// =============================================================================

import { Action } from '../types';

/**
 * Data structure for dragged action
 */
export interface DraggedActionData {
  type: 'doelstellingen-action';
  actionId: string;
  actionTitle: string;
  goalId: string;
  milestoneId?: string | null;
}

/**
 * Create drag data for an action
 */
export function createActionDragData(action: Action): DraggedActionData {
  return {
    type: 'doelstellingen-action',
    actionId: action.id,
    actionTitle: action.title,
    goalId: action.goalId,
    milestoneId: action.milestoneId,
  };
}

/**
 * Parse drag data from dataTransfer
 */
export function parseActionDragData(dataTransfer: DataTransfer): DraggedActionData | null {
  try {
    const data = dataTransfer.getData('application/json');
    if (!data) return null;
    
    const parsed = JSON.parse(data);
    if (parsed.type !== 'doelstellingen-action') return null;
    
    return parsed as DraggedActionData;
  } catch {
    return null;
  }
}

/**
 * Set drag data on dataTransfer
 */
export function setActionDragData(dataTransfer: DataTransfer, data: DraggedActionData): void {
  dataTransfer.setData('application/json', JSON.stringify(data));
  dataTransfer.effectAllowed = 'copy'; // Kopiëren, niet verplaatsen
}
